// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toast-container[data-v-0dd7855d]{align-items:center;display:flex;gap:24px;justify-content:space-between;min-width:300px;width:-moz-max-content;width:max-content}.toast-container__message[data-v-0dd7855d]{font-size:24px;font-weight:500;line-height:130%;max-width:375px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
